import {
  FETCH_TOPIC_SESSION_LIST,
  FETCH_TOPIC_SESSION_LIST_START,
  FETCH_TOPIC_SESSION_LIST_ERROR,
} from "../constants/ActionTypes";

// Lists are stored BY SLUG: { [slug]: { items, isLoading, hasError, loaded } }.
// An editor selects only its own topic's entry, so a fetch, a failure or a
// late post-save refresh for one topic can never reach another topic's editor.
// `loaded` means "items came from a successful fetch of this topic" — editors
// stay read-only until it is true.
// `requestId` is the latest fetch started for the topic: a completion from an
// older, superseded request (the topic was left and reopened mid-fetch) is
// ignored, so it can never overwrite newer data or disable a loaded editor.
const EMPTY_ENTRY = { items: null, isLoading: false, hasError: false, loaded: false, requestId: null };

export default function topicSessionListReducer(state = {}, action) {
  const entry = state[action.slug] || EMPTY_ENTRY;
  const requestId = action.requestId ?? null;
  const isSuperseded = requestId !== entry.requestId;
  switch (action.type) {
    case FETCH_TOPIC_SESSION_LIST_START:
      // Drop the cached list: after a save whose refresh failed it can be
      // stale, and editing it while this fetch is pending would save it back.
      return { ...state, [action.slug]: { ...EMPTY_ENTRY, isLoading: true, requestId } };
    case FETCH_TOPIC_SESSION_LIST:
      if (isSuperseded) return state;
      return {
        ...state,
        [action.slug]: { ...entry, items: action.payload, isLoading: false, hasError: false, loaded: true },
      };
    case FETCH_TOPIC_SESSION_LIST_ERROR:
      if (isSuperseded) return state;
      return { ...state, [action.slug]: { ...entry, isLoading: false, hasError: true } };
    default:
      return state;
  }
}
